import { Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizedDatePipe } from '../../../pipes/localized-date.pipe';

/** Piliers du programme — clés de catégorie utilisées par les filtres et les badges. */
export type OpportunityCardTone =
  | 'emploi'
  | 'formation'
  | 'financement'
  | 'innovation'
  | 'citoyennete'
  | 'autre';

export interface OpportunityCardData {
  /** Slug public, utilisé pour le routage (/opportunities/:slug). */
  id: string;
  /** UUID réel de l'opportunité côté opportunity-service, utilisé pour les favoris et le tracking. */
  opportunityId: string;
  title: string;
  org: string;
  /** Code région (referentials.ts) — null si l'opportunité couvre toutes les régions. */
  regionCode: string | null;
  tone: OpportunityCardTone;
  /** Date de clôture brute (ISO) — à formater au rendu via le pipe `localizedDate`. */
  closingDate: string | null;
  urgent?: boolean;
  applicationsEnabled: boolean;
  /** Photo de couverture (opportunity-service) ; null la plupart du temps, la carte retombe alors sur le badge coloré. */
  coverImageUrl?: string | null;
}

/** Couleurs des badges par pilier (design system YCC, composant Badge). */
export const TONE_STYLES: Record<OpportunityCardTone, { bg: string; fg: string }> = {
  emploi: { bg: '#FAE4E7', fg: '#B01D30' },
  formation: { bg: '#EAF0FF', fg: '#2563EB' },
  financement: { bg: '#FBF3DE', fg: '#8A6414' },
  innovation: { bg: '#E4F3FA', fg: '#0678AC' },
  citoyennete: { bg: '#E9F4E4', fg: '#3A7A2B' },
  autre: { bg: '#EEF0F2', fg: '#4B5563' },
};

@Component({
  selector: 'app-opportunity-card',
  imports: [TranslatePipe, LocalizedDatePipe],
  templateUrl: './opportunity-card.html',
  styleUrl: './opportunity-card.css',
  host: { class: 'block h-full' },
})
export class OpportunityCard {
  readonly opportunity = input.required<OpportunityCardData>();
  readonly saved = input(false);

  readonly toggleSave = output<string>();
  readonly open = output<string>();

  readonly toneStyle = computed(() => TONE_STYLES[this.opportunity().tone]);
}
